import { render, staticRenderFns } from "./qahelper.vue?vue&type=template&id=c50e299a&"
import script from "./qahelper.vue?vue&type=script&lang=js&"
export * from "./qahelper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports